import React, {useState} from 'react';
import styled from "styled-components";
import {Table} from "react-materialize";

import TransactionsList from "./TransactionsList.react";
import TableHeader from "./TableHeaders.react";
import UnreconciledModal from "./UnreconciledModal.react";

const StyledContainer = styled.div`
  td:last-of-type, th:last-of-type {
    width: 11rem;
  }
`

const UnreconciledTransactions = ({transactions, loading}) => {
  const [transaction, setTransaction] = useState(null);
  const [open, setOpen] = useState(false);

  const handleTransactionSelect = (transaction) => {
    setTransaction(transaction);
    setOpen(true);
  }

  const handleClose = () => {
    setTransaction(null);
    setOpen(false);
  }

  return (
    <StyledContainer className={'content-container'}>
      <Table striped>
        <TableHeader />
        <TransactionsList transactions={transactions} handleTransactionSelect={handleTransactionSelect} loading={loading} />
      </Table>
      <UnreconciledModal handleClose={handleClose} show={open} transaction={transaction} />
    </StyledContainer>
  )
}

export default UnreconciledTransactions;